import {defineStore} from "pinia";
import {useAuthStore} from "@/stores/authStores";
import api from "@/services/api";


export const useAlarmsStore = defineStore('alarms', {
    state: () => ({
        alarmsHistory: [],
        selected: [],
        defaultPopupConfig: {},

        popupConfig: {},

        lostAlarm: false,
        alarmHistoryActive: false
    }),

    getters: {
        getHistory: state => {
            // Sort the alarms by timestamp in descending order
            return state.alarmsHistory.sort((a, b) => {
                return new Date(b.timestamp) - new Date(a.timestamp);
            });
        }

    },

    actions: {
        acknowledge(id) {
            api.put(
                '/alarms/acknowledge',
                {},
                {
                    headers: {'Content-Type': 'application/json'},
                    params: {
                        id: id,
                        ackBy: useAuthStore().loggedUser,
                        ackTime: Date.now(),
                    }
                }
            )
                .then(() => {
                    this.fetchHistory();
                })
                .catch(error => {
                    console.error("There was an error acknowledging the alarm: ", error);
                });
        },

        fetchHistory() {
            api.get('/alarms/getHistory')
                .then(response => {
                    this.alarmsHistory = response.data;
                })
                .catch(error => {
                    console.error("There was an error fetching the call history: ", error);
                });
        },

        resetPopupConfig() {
            this.popupConfig = this.defaultPopupConfig;
        },

        getDefaultPopupConfig() {
            api.get('/alarms/getAlarmCategories')
                .then(response => {
                    for (const category of response.data) {
                        this.defaultPopupConfig[category] = true;
                    }
                    this.resetPopupConfig();
                })
                .catch(error => {
                    console.error("There was an error fetching the call history: ", error);
                });
        }
    }
})